// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"1e0cb06d","489":"bb1d4b12"}[chunkId] + ".chunk.css";
};